(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nc-breadcrumbs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nc-recent-tracker')) {
    customElements.define('nc-recent-tracker', class extends HTMLElement {
      connectedCallback() {
        const handle = this.dataset.handle;
        if (!handle) return;
        try {
          const stored = JSON.parse(localStorage.getItem('nc-recent-products') || '[]');
          const next = [handle, ...stored.filter((item) => item !== handle)].slice(0, 8);
          localStorage.setItem('nc-recent-products', JSON.stringify(next));
        } catch (error) {
          localStorage.removeItem('nc-recent-products');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nc-fbt"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nc-fbt')) {
    customElements.define('nc-fbt', class extends HTMLElement {
      connectedCallback() {
        this.querySelector('[data-add-all]')?.addEventListener('click', () => this.addAll());
        document.addEventListener('shopify:product:select', this.onProductSelect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:product:select', this.onProductSelect);
      }

      onProductSelect = (event) => {
        event.promise?.then(({ detail }) => {
          if (String(detail?.productId) !== String(this.dataset.productId)) return;
          const variantId = detail?.resource?.id;
          const price = Number(detail?.resource?.price);
          if (!variantId) return;

          const script = this.querySelector('[data-items]');
          const items = JSON.parse(script.textContent);
          const primary = items.find((item) => item.primary);
          if (primary) primary.id = variantId;
          script.textContent = JSON.stringify(items);

          if (Number.isFinite(price)) {
            const totalNode = this.querySelector('[data-total]');
            const total = price + Number(this.dataset.pairTotal || 0);
            if (totalNode) totalNode.textContent = this.formatMoney(total);
          }
        }).catch(() => {});
      };

      formatMoney(cents) {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency: this.dataset.currency || 'USD'
        }).format(cents / 100);
      }

      async addAll() {
        const button = this.querySelector('[data-add-all]');
        const message = this.querySelector('[data-message]');
        const items = JSON.parse(this.querySelector('[data-items]').textContent)
          .filter((item) => item.id)
          .map(({ id, quantity }) => ({ id, quantity }));
        if (items.length < 2) return;

        button.disabled = true;
        message.textContent = 'Adding your routine…';
        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items, sections: 'cart-drawer-section', sections_url: window.location.pathname })
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || 'Unable to add these products.');

          const html = data.sections?.['cart-drawer-section'];
          const current = document.querySelector('#shopify-section-cart-drawer-section');
          if (html && current) {
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const next = parsed.querySelector('#shopify-section-cart-drawer-section');
            if (next) current.replaceWith(next);
          }
          document.querySelector('[aria-controls="cart-drawer"]')?.click();
          message.textContent = 'Added to cart.';
        } catch (error) {
          message.textContent = error.message;
        } finally {
          button.disabled = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nc-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nc-recent-products')) {
    customElements.define('nc-recent-products', class extends HTMLElement {
      async connectedCallback() {
        let handles = [];
        try { handles = JSON.parse(localStorage.getItem('nc-recent-products') || '[]'); } catch (error) { localStorage.removeItem('nc-recent-products'); }
        handles = handles.slice(0, Number(this.dataset.limit) || 4);
        if (!handles.length) return;
        const products = (await Promise.all(handles.map(async (handle) => {
          const response = await fetch(`${window.Shopify.routes.root}products/${encodeURIComponent(handle)}.js`);
          return response.ok ? response.json() : null;
        }))).filter(Boolean);
        if (!products.length) return;
        const grid = this.querySelector('[data-grid]');
        const currency = window.Shopify?.currency?.active || 'USD';
        const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency });
        products.forEach((product) => {
          const card = document.createElement('article');
          const link = document.createElement('a');
          link.href = product.url;
          link.className = 'nc-recently-viewed__media';
          if (product.featured_image) {
            const image = document.createElement('img');
            image.src = product.featured_image;
            image.alt = product.title;
            image.loading = 'lazy';
            link.append(image);
          }
          const title = document.createElement('h3');
          const titleLink = document.createElement('a');
          titleLink.href = product.url;
          titleLink.textContent = product.title;
          title.append(titleLink);
          const price = document.createElement('p');
          price.textContent = money.format(product.price / 100);
          card.append(link, title, price);
          grid.append(card);
        });
        this.closest('.nc-recently-viewed').hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
